export default {
	"subscribe.MallRenewalManagementCancelSubscriptionPopupButtonClick": "Mall Renewal Management_Cancel Subscription Popup_Button Click",
	"subscribe.Cancel": "Cancel",
	"subscribe.CancelTheContractSuccessfully": "Cancel the contract successfully",
	"subscribe.systemError": "system error",
	"subscribe.StoreRenewalManagementRenewalEntry": "Store Renewal Management_Renewal Entry",
	"subscribe.CloseRenewal": "Close renewal",
	"subscribe.ClickToTurnOffAutoRenewal": "Click to turn off auto-renewal",
	"subscribe.TurnOnRenewal": "Turn on renewal",
	"subscribe.expired": "expired",
	"subscribe.completed": "completed",
	"subscribe.StoreRenewalManagementUnsubscribePopup": "Store Renewal Management_Unsubscribe popup",
	"subscribe.ParameterError": "Parameter error!",
	"subscribe.subscriptionTime": "subscription time",
	"subscribe.nextRenewalTime": "next renewal time",
	"subscribe.LastRenewalTime": "Last renewal time",
	"subscribe.AmountPerRenewal": "Amount per renewal",
	"subscribe.Yuan": "Yuan",
	"subscribe.WeChatPay": "WeChat Pay",
	"subscribe.payByAliPay": "pay by AliPay",
	"subscribe.AutoRenewalBenefits": "Auto-renewal benefits",
	"subscribe.saveTimeAndEnergy": "save time and energy",
	"subscribe.AutomaticRenewalUponExpiration": "Automatic renewal upon expiration",
	"subscribe.exclusivePrivilege": "exclusive privilege",
	"subscribe.EnjoyPremiumContent": "Enjoy premium content",
	"subscribe.124HoursBeforeTheExpirationOfEachSubscriptionTheSystemWillAutomaticallyDeductTheFeeFromTheContractedAccountAndActivateTheContentExperiencePermissionForTheNewSubscriptionCycle": "1. 24 hours before the expiration of each subscription, the system will automatically deduct the fee from the contracted account, and activate the content experience permission for the new subscription cycle.",
	"subscribe.2ThereMayBeADelayInFeedbackDueToThePaymentPlatformForTheActualSubscriptionPleaseReferToTheSubscriptionRecord": "2. There may be a delay in feedback due to the payment platform. For the actual subscription, please refer to the subscription record.",
	"subscribe.AutomaticSubscriptionClosingPrompt": "Automatic subscription closing prompt",
	"subscribe.AfterClosingTheSubscriptionTheSystemWillNotBeAbleToMakeSubsequentDeductionsAndYouWillNotBeAbleToUnlockTheCorrespondingRightsOnTimeAreYouSureYouWantToCancel": "After closing the subscription, the system will not be able to make subsequent deductions, and you will not be able to unlock the corresponding rights on time. Are you sure you want to cancel?",
	"subscribe.continueToCancel": "continue to cancel",
	"subscribe.doNotCancel": "do not cancel"
}